import { render, staticRenderFns } from "./bgSlide.vue?vue&type=template&id=838fa038"
import script from "./bgSlide.vue?vue&type=script&lang=js"
export * from "./bgSlide.vue?vue&type=script&lang=js"
import style0 from "./bgSlide.vue?vue&type=style&index=0&id=838fa038&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports